module.exports = __webpack_public_path__ + "static/contribution_img2@2x-f31b13783dff4ab30fa74bce5604e5e5.jpg";